import { render, staticRenderFns } from "./BaseTableHeader.vue?vue&type=template&id=ede203ec"
import script from "./BaseTableHeader.vue?vue&type=script&lang=js"
export * from "./BaseTableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports